import { Card, CardBody, Col, Row } from "reactstrap";
import { useLocation } from "react-router-dom";

const ThankYouRegisterTabs = () => {
  const location = useLocation();
  const {
    userName = "test",
    userId = "SSC85847583",
    password = "123456",
  } = location.state || {};

  return (
    <Row
      className="justify-content-center align-items-center"
      style={{ minHeight: "70vh" }}
    >
      <Col md="8" xl="6">
        <Card
          className="p-4 shadow-sm"
          style={{ borderRadius: "12px", border: "none" }}
        >
          <CardBody className="text-center">
            <h2 style={{ fontWeight: 600, color: "#656565" }}>THANK YOU,</h2>
            <h4
              style={{ fontWeight: 500, color: "#74b32b", marginTop: "-4px" }}
            >
              YOUR REGISTRATION IS SUCCESSFUL.
            </h4>

            <div
              className="mx-auto mt-4 mb-2"
              style={{
                border: "2px dashed #9AC4D4",
                borderRadius: "10px",
                padding: "32px 24px",
                maxWidth: "410px",
                fontSize: "1.07rem",
                background: "#fafdff",
              }}
            >
              <div style={{ textAlign: "left" }}>
                <div className="mb-2 text-secondary small">
                  Congratulations, you have completed the online application
                  process.
                  <br />
                  <span>
                    To sign in to your ‘Sukanya Swastik Care Dashboard’, please
                    use:
                  </span>
                </div>
                <div
                  style={{
                    fontWeight: 500,
                    marginTop: "12px",
                    fontSize: "0.875rem",
                  }}
                >
                  <span style={{ display: "block", marginBottom: "4px" }}>
                    <strong>User Name:</strong> {userName}
                  </span>
                  <span style={{ display: "block", marginBottom: "4px" }}>
                    <strong>User ID:</strong> {userId}
                  </span>
                  <span style={{ display: "block", marginBottom: "4px" }}>
                    <strong>Password:</strong> {password}
                  </span>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ThankYouRegisterTabs;
